import React from 'react';
import { connect } from 'react-redux';
import CasesEmployeePres from 'src/ui/features/Cases/presentational/CasesEmployeePres';
import { resetCaseManagerId } from 'src/ui/features/Cases/state/casesActions';
import { resumeDraftMode } from 'src/ui/features/Messaging/state/messagingActions';

class CasesEmployeeContainer extends React.Component {
  state = {
    viewType: 'details',
  };

  componentDidMount() {}

  handleView = viewType => {
    this.setState({ viewType });
  };

  render() {
    const { applicant, isCorpClient } = this.props;
    return (
      <CasesEmployeePres
        applicant={applicant}
        viewType={this.state.viewType}
        isCorpClient={isCorpClient}
        onUpdateView={this.handleView}
      />
    );
  }
}

const mapStateToProps = state => ({});
const mapDispatchToProps = {
  resumeDraftMode,
  resetCaseManagerId,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CasesEmployeeContainer);
